import * as CL from '@design-system/component-library';
import { dsClass } from '../../../../../common/constants/dsClasses.js';
import { t } from '../../../../../common/i18n/index.js';
import { RecordInput } from './RecordInput.js';
import { validateHostname, validatePort, validatePriority, validateWeight } from './fieldValidation.js';

export const SRVValueField = ({ index }: { index: number }) => (
  <div className={dsClass.DISPLAY_FLEX}>
    <CL.GridCol colsXS={2}>
      <RecordInput label={t.A6M3('target')} name="target" validate={validateHostname} index={index} />
    </CL.GridCol>
    <CL.GridCol colsXS={2}>
      <div className={dsClass.DISPLAY_FLEX}>
        <div className={dsClass.MARGIN_RIGHT_2}>
          <RecordInput label={t.UUO7('Weight')} name="weight" type="number" validate={validateWeight} index={index} />
        </div>
        <div className={dsClass.MARGIN_RIGHT_2}>
          <RecordInput label={t.BW68('Port')} name="port" type="number" validate={validatePort} index={index} />
        </div>
        <div className={dsClass.MARGIN_RIGHT_2}>
          <RecordInput
            label={t.ZS4S('Priority')}
            name="priority"
            type="number"
            validate={validatePriority}
            index={index}
          />
        </div>
      </div>
    </CL.GridCol>
  </div>
);
